import React, { useContext } from 'react';
import { initialDateState } from '../ducks/dateDuck';

const DateContext = React.createContext({
  state: initialDateState,
  dispatch: null,
});

export const useDateContext = () => useContext(DateContext);

export const useDateSelector = (selector, ...params) => {
  const { state, props } = useDateContext();
  return selector({
    state,
    props,
  }, ...params);
};

export const useDateDispatch = () => {
  const { dispatch } = useDateContext();
  return dispatch;
};

export default DateContext;
